// Entry point for the application
import "@hotwired/turbo-rails"
import "./controllers"
import { debug } from "./debug"
import "./initializers/marked"  // Initialize marked.js with custom tokenizer


// Debug information for Turbo
document.addEventListener('turbo:load', () => {
  debug("Turbo load event fired");
  
  // Force CSS reload on Turbo navigation
  const stylesheets = document.querySelectorAll('link[rel="stylesheet"]');
  stylesheets.forEach(stylesheet => {
    const originalHref = stylesheet.getAttribute('href');
    if (originalHref) {
      stylesheet.setAttribute('href', originalHref);
      debug("Forced stylesheet reload:", originalHref);
    }
  });
});

document.addEventListener('turbo:before-visit', () => {
  debug("Turbo before-visit event fired");
});

document.addEventListener('turbo:visit', () => {
  debug("Turbo visit event fired");
});

// Ensure menu works with Turbo
document.addEventListener('turbo:render', () => {
  debug("Turbo render event fired");
});

// Log Stimulus controller definitions for debugging after Turbo load
if (window.Turbo) {
  document.addEventListener('turbo:load', function() {
    if (window.Stimulus) {
      debug('Turbo load complete. Stimulus controller definitions:', window.Stimulus.controllerDefinitions);
    }
  });
}

// Note: Controllers are now registered via controllers/index.js
debug("Main application.js loaded - Stimulus setup is handled by ./controllers/index.js");
